import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_err) {
      // Intentional silent fail: even if the server-side cookie clear fails (network down,
      // already expired, etc.), we still want to clear local state and redirect.
    }
    setUser(null);
    window.location.href = "/";
  };

  const roles = user?.roles || [];
  const isAdmin = roles.includes("admin");
  const hasRole = (...needed) => isAdmin || needed.some((r) => roles.includes(r));
  const canWrite = (domain) => isAdmin || roles.includes(domain);
  const hasAnyRole = roles.length > 0;

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout, roles, isAdmin, hasRole, canWrite, hasAnyRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
